import AutoComplete from "src/decidim/autocomplete";
$(() => {
  $("[data-decidim-geocoding]").each((_i, el) => {
    const $input = $(el);
    const autoComplete = new AutoComplete(el, {
      mode: "single",
      dataMatchKeys: ["value"],
      dataSource: (query, callback) => {
        $input.trigger("geocoder-suggest.decidim", [query, callback]);
      }
    });
    el.addEventListener("selection", autoComplete);
    $input.on("selection", (event) => {
      const selectedItem = event.detail.selection.value;
      $input.trigger("geocoder-suggest-select.decidim", [selectedItem]);
      if (selectedItem.coordinates) {
        $input.trigger("geocoder-suggest-coordinates.decidim", [selectedItem.coordinates]);
      }
    });
  });
});
